import React from "react";

const HeaderSpacer = () => {
  return <div style={{ height: "4.5rem" }} />;
};

export default HeaderSpacer;
